import { useParams } from 'react-router-dom';

/**
 * URL helper utilities following APFP pattern
 */

/**
 * Extract fund request ID from URL path
 * Following APFP pattern: document.location.pathname.split("/")[2]
 * For URL: /fund-requests/FR-123/details -> returns "FR-123"
 */
export const getFundRequestId = () => {
  return document.location.pathname.split("/")[2];
};

/**
 * React Router hook version for getting fund request ID
 * More robust than pathname splitting
 */
export const useFundRequestId = () => {
  const { id } = useParams();
  return id;
};

/**
 * Check if current path matches a pattern
 */
export const isCurrentPath = (path) => {
  return document.location.pathname === path;
};

/**
 * Check if we're on a fund request details page
 */
export const isFundRequestDetailsPage = () => {
  return document.location.pathname.includes('/fund-requests/') && 
         document.location.pathname.includes('/details');
};

/**
 * Generate fund request details URL
 */
export const getFundRequestDetailsUrl = (fundRequestId) => {
  return `/fund-requests/${fundRequestId}/details`;
};

/**
 * Validate fund request ID format
 * Basic validation for fund request ID pattern
 */
export const isValidFundRequestId = (id) => {
  if (!id || typeof id !== 'string') return false;
  
  // Basic pattern check for fund request IDs
  // Adjust pattern based on your actual ID format
  const pattern = /^FR-[A-Z]+-[A-Z]+-[A-Za-z0-9]+-[A-Za-z0-9]+$/;
  return pattern.test(id);
};

/**
 * Get current route name for display
 */
export const getCurrentRouteName = () => {
  const { pathname } = window.location;
  
  if (pathname === '/dashboard') return 'Dashboard';
  if (pathname === '/fund-request-queue') return 'Fund Request Queue';
  if (pathname === '/event-history') return 'Event History';
  if (pathname === '/reporting') return 'Reporting';
  if (isFundRequestDetailsPage()) return 'Fund Request Details';
  
  return 'Chronos';
};